<template>
  <v-btn
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="default"
      @click="submit"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon>
      mdi-play
    </v-icon>

    <slot/>
  </v-btn>
</template>

<script>
  import Cron from '@/services/cron'

  export default {
    name: 'ProcessItems',
    data() {
      return {
        loading: false
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      loadData() {

      },
      async submit() {
        this.loading = true

        await Cron
          .processItems()
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            window.location.reload()
          })
          .catch((error) => {
            switch (error.response.status) {
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
